<template>
    <UniversalTable v-if="isUniversalTable" :value="tableData"/>
    <component v-else :tickets="tickets" :layout="layout" :is="tableComponent"/>
</template>

<script>
import { mapState } from 'vuex'
import TableSimple from '@/components/table/TableSimple'
import TableCols from '@/components/table/TableCols'
import { layouts, colorSchemes } from '@/app/const/settings'
import TableState from '@/components/table/TableState.vue'
import TableAd from '@/components/table/TableAd.vue'
import TableVerticalAd from '@/components/table/TableVerticalAd.vue'
import TableDiffClients from '@/components/table/TableDiffClients.vue'
import ClientsQueue from '@/app/model/clients/clients-queue'
import UniversalTable from '@/components/table/UniversalTable.vue'
import ColumnModel from '@/app/model/universal/Column.model'
import TableModel from '@/app/model/universal/Table.model'

export default {
    name: 'TableManager',
    components: { UniversalTable },
    props: {
        tickets: {
            type: [Array, ClientsQueue]
        }
    },
    computed: {
        ...mapState({
            guiSettings: state => state.gui.settings
        }),
        layout () {
            return this.guiSettings.layout.code
        },
        colorScheme () {
            return this.guiSettings.colorScheme
        },
        tableComponent () {
            switch (this.layout) {
                case layouts.default:
                    return TableSimple
                case layouts.col2:
                case layouts.col3:
                    return TableCols
                case layouts.colAd:
                    return TableAd
                case layouts.col2State:
                    return TableState
                case layouts.col2DiffClients:
                    return TableDiffClients
                case layouts.col1Ad:
                case layouts.col2Ad:
                    return TableVerticalAd
                default:
                    return undefined
            }
        },
        isUniversalTable () {
            return (this.colorScheme.code === colorSchemes.baucenter && this.layout === layouts.col2State) || this.layout === layouts.col3Flag
        },
        tableData () {
            if (this.layout === layouts.col3Flag) {
                const columns = [
                    new ColumnModel('Ожидают', 2, false, this.tickets.filter(t => t.screenStateId === 1).reverse(), true),
                    new ColumnModel('Готовы к выдаче здесь', 1, true,
                        this.tickets.filter(t => (t.screenStateId === 2 || t.screenStateId === 4) && !t.isShowInOtherBlock()), true
                    ),
                    new ColumnModel('Готовы к выдаче на улице', 1, true,
                        this.tickets.filter(t => (t.screenStateId === 2 || t.screenStateId === 4) && t.isShowInOtherBlock()), true
                    )
                ]
                return new TableModel(columns)
            }
            if (this.colorScheme.code === colorSchemes.baucenter) {
                if (this.layout === layouts.col2State) {
                    const columns = [
                        new ColumnModel('Ожидают', 2, false, this.tickets.filter(t => t.screenStateId === 1).reverse(), true),
                        new ColumnModel('Готовы к выдаче', 2, true,
                            this.tickets.filter(t => (t.screenStateId === 2 || t.screenStateId === 4)), true, { 'flex-grow': '1' })
                    ]
                    return new TableModel(columns)
                }
            }
            return undefined
        }

    }
}
</script>
